<template>
    <carousel :perPageCustom="[[0,1], [600,2], [992,4]]" :navigationClickTargetSize="14" :loop="true"
              :autoplay="true" :autoplayTimeout="7000" :navigationEnabled="true" :paginationEnabled="false"
              navigationPrevLabel="<i class='glyphicon glyphicon-menu-left'></i>" navigationNextLabel="<i class='glyphicon glyphicon-menu-right'></i>">
        <slide v-for="slide in slides" :key="slide.logo.url" class="text-center col-xs-12">
            <div class="vueslide">
                <a :href="slide.link">
                    <img :src="slide.logo.url" :alt="slide.logo.alt" class="img img-responsive lazy">
                    <a :href="slide.link" class="link">>> {{ slide.title }}</a>
                </a>
            </div>
        </slide>
    </carousel>
</template>

<script>
    import VueCarousel from "vue-carousel";

    export default {
        props: ['slides'],
        name: "discountPartnerSlider",
        components: {
            'carousel': VueCarousel.Carousel,
            'slide': VueCarousel.Slide
        }
    };
</script>

<style scoped>
    .img {
        width: auto;
        max-height: 125px;
        margin: 0 auto;
    }
</style>
